import underscored from 'underscore.string/underscored';

angular.module('gym.reports').controller('BulkMemberPortalOperationsCtrl', ["$scope", "$state", "$rootScope", "flash", "Contacts", "Restangular", "EmploymentService", "ngTableParams", "loadingAnimation", "ContactBadgeService", "MessageService", function($scope, $state, $rootScope, flash, Contacts, Restangular, EmploymentService, ngTableParams, loadingAnimation, ContactBadgeService, MessageService) {
  var areContactsEqual, getPerformFilters, gym, permissions, selectedContactsIds, sendInvites;
  gym = $rootScope.gym;
  permissions = EmploymentService.get().permissions;
  if (!permissions.perform_bulk_member_portal_operations || !gym.member_portal_enabled) {
    $state.go('gym.dashboard');
  }
  $scope.allPagesSelected = false;
  $scope.toggleSelectAllPages = function() {
    return $scope.allPagesSelected = !$scope.allPagesSelected;
  };
  $scope.pageParams = {
    'filters[member_status]': 'Active',
    'filters[portal_status]': 'Enabled'
  };
  $scope.getContactBadge = function(type, status) {
    return ContactBadgeService.get(type, status);
  };
  $scope.memberStatuses = [['Active', 'Active'], ['Cancelled', 'Cancelled'], ['Suspended', 'Suspended']];
  $scope.portalStatuses = [['Enabled', 'Enabled'], ['Disabled', 'Disabled']];
  $scope.contactsType = function(type) {
    return `${underscored(type)}s`;
  };
  $scope.onSearch = function() {
    return $scope.tableParams.reload();
  };
  $scope.debouncedSearch = _.debounce($scope.onSearch, 400);
  areContactsEqual = function(first, second) {
    return first.id === second.id;
  };
  $scope.selectedContacts = [];
  $scope.isContactSelected = function(contact) {
    return _.find($scope.selectedContacts, function(selected) {
      return areContactsEqual(selected, contact);
    });
  };
  $scope.toggleContact = function(contact) {
    if ($scope.isContactSelected(contact)) {
      $scope.selectedContacts = _.reject($scope.selectedContacts, function(selected) {
        return areContactsEqual(selected, contact);
      });
      return $scope.allPagesSelected = false;
    } else {
      return $scope.selectedContacts.push(contact);
    }
  };
  $scope.toggleAll = function() {
    var availableContacts;
    return $scope.selectedContacts = (function() {
      switch (false) {
        case !$scope.isAllContactsSelected():
          $scope.allPagesSelected = false;
          return [];
        default:
          availableContacts = $scope.contacts.filter(function(contact) {
            return !contact.unsubscribed_from_email;
          });
          return _.uniq($scope.selectedContacts.concat(availableContacts), function(item) {
            return item.id;
          });
      }
    })();
  };
  $scope.isAllContactsSelected = function() {
    var ref;
    return ((ref = $scope.contacts) != null ? ref.length : void 0) && _.every($scope.contacts, function(contact) {
      return contact.unsubscribed_from_email || $scope.isContactSelected(contact);
    });
  };
  selectedContactsIds = function() {
    return _.uniq($scope.selectedContacts.map(function(item) {
      return item.id;
    }));
  };
  $scope.contactsReady = function() {
    var ref;
    return (ref = $scope.selectedContacts) != null ? ref.length : void 0;
  };
  $scope.confirm = function(action, sendInviteEmail) {
    var message, ref, selectedCount;
    selectedCount = $scope.allPagesSelected ? $scope.meta.total : (ref = $scope.selectedContacts) != null ? ref.length : void 0;
    message = (function() {
      switch (false) {
        case !(action === 'enable_portal' && sendInviteEmail):
          return [`This will enable the member portal for ${selectedCount} selected members. An email with login instructions will also be sent to the member.`, 'If the portal is already enabled for a member, no change will be made.'];
        case !(action === 'enable_portal' && !sendInviteEmail):
          return [`This will enable the member portal for ${selectedCount} selected members.`, 'If the portal is already enabled for a member, no change will be made.'];
        case action !== 'disable_portal':
          return [`This will disable the member portal for ${selectedCount} selected members.`, 'If the portal is already disabled for a member, no change will be made.'];
        case action !== 'send_invite_email':
          return [`This will send member portal login instructions to ${selectedCount} selected members.`, 'If the portal is currently disabled for any of the members, no email will be sent.'];
        default:
          return '';
      }
    })();
    return MessageService.message({
      title: 'Confirm Selection',
      message: message,
      displayOkButton: true
    }).then(function() {
      return sendInvites(action, sendInviteEmail);
    });
  };
  getPerformFilters = function() {
    var params;
    params = {};
    _.each($scope.pageParams, function(val, key) {
      var newKey;
      newKey = key.replace('filters[', '').replace(']', '');
      return params[newKey] = val;
    });
    return params;
  };
  sendInvites = function(action, sendInviteEmail) {
    var params;
    params = {
      withoutNamespace: true,
      bulk_member_portal_operation: {
        action: action,
        send_invite_email: sendInviteEmail,
        contact_ids: selectedContactsIds()
      }
    };
    if ($scope.allPagesSelected) {
      params.bulk_member_portal_operation.contact_ids = [];
      params.select_all_pages = 1;
      params.filters = getPerformFilters();
    }
    loadingAnimation.show();
    return Restangular.one('gyms', gym.id).all('member_portals').doPOST(params, 'perform').then(function() {
      flash.success = 'Updated successfully';
      return $scope.tableParams.reload();
    }, function() {
      loadingAnimation.hide();
      return flash.error = 'Something went wrong, please try again later';
    });
  };
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 100
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      $scope.selectedContacts = [];
      loadingAnimation.show();
      $scope.allPagesSelected = false;
      params = angular.extend($params.url(), $scope.pageParams);
      return Contacts.all('with_member_portals').getList(params).then(function(data) {
        $params.total(data.meta.total);
        $scope.meta = data.meta;
        loadingAnimation.hide();
        $scope.contacts = data.plain();
        return $defer.resolve(data);
      });
    }
  });
}]);
